import Alpine from 'alpinejs';

const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

Alpine.magic('smoothscroll', () => (selector, { updateUrl = true } = {}, callback) => {
  const targetEl = document.querySelector(selector);

  if (!targetEl) {
    console.warn(`$smoothscroll: no element found for selector "${selector}"`);
    return;
  }

  const y = targetEl.getBoundingClientRect().top + window.scrollY - 100;

  /*
  targetEl.scrollIntoView({
    behavior: prefersReducedMotion ? 'auto' : 'smooth',
    block: 'start',
  });
   */

  function callbackHandler(e) {
    callback();
    window.removeEventListener('scrollend', callbackHandler);
  }

  window.addEventListener('scrollend', callbackHandler);

  window.scrollTo({ top: y, behavior: prefersReducedMotion ? 'instant' : 'smooth' });

  if (updateUrl) {
    history.pushState(null, '', selector);
  }
});
